import { createSelector } from 'reselect';

import { calculateAverageRating } from '../../utilities/rating';

import { AppState } from '../types';

export const getRating = (state: AppState) => state.rating;

export const getAverageRating = createSelector(getRating, rating => (rating ? calculateAverageRating(rating) : null));
